var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({attrs:{"color":_vm.color,"depressed":_vm.depressed},on:{"click":_setup.onClick}},'v-btn',_vm.$attrs,false),[_vm._t("default",function(){return [_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-send")]),_vm._v(" 送信 ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }